"use client";

import { useFloatingContext } from "@faire/slate/private/floating/FloatingContext";
import { FloatingOverlay } from "@floating-ui/react";
import React from "react";
import { twMerge } from "tailwind-merge";

import { useModalContext } from "./ModalContext";

export const ModalOverlay: React.FC<
  React.PropsWithChildren<{ className?: string }>
> = ({ children, className }) => {
  const { open } = useFloatingContext();
  const { animating } = useModalContext();

  return (
    <FloatingOverlay
      lockScroll
      className={twMerge("fs-modal__overlay", className)}
      data-animating={animating}
      data-open={open}
    >
      {children}
    </FloatingOverlay>
  );
};
